import type { Currency, CurrencyCounterValueRequest, CurrencyExchangeResult, CurrencyItem } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { post, get } from './request';

const SERVICE_PATH = 'rest/resource/currencies';

export const getCounterValue = (from: Currency, to: Currency, amount: number): Promise<CurrencyExchangeResult> => {
    const request: CurrencyCounterValueRequest = {
        from,
        to,
        amount,
    };
    return post<CurrencyExchangeResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/countervalue`, request);
};

export function getCurrencies(): Promise<CurrencyItem[]> {
    return get<CurrencyItem[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}
